<template>
  <!-- @TODO: sorting (REST implement PagingAndSorting), AppUser clean identifier, char limit on inputarea(255) -->
  <div  class="p-3">
    <div  class="row align-items-center mb-3 mx-0">
      <el-radio-group @change="startEditing" v-model.number="editMode" size="small" class="pl-0 col">
        <el-radio-button class="px-0 my-0" label=0>Preview</el-radio-button>
        <el-radio-button class="my-0" label=1>Edit&nbsp<i class="fa fa-edit"></i></el-radio-button>
      </el-radio-group>
      <el-button
        v-if="!newNote && editMode"
        type="primary"
        plain
        class="col-auto mr-3"
        size="small"
        style="font-size: 12px"
        @click="addNote" round>
        <i class="el-icon-plus"></i>&nbsp;New
      </el-button>
      </div>
          <div v-show="!editMode" class="p-3">
            <p class="px-3" v-if="!notesPreview || notesPreview.length === 0">No notes have been included in the submission.
              Go to Edit to create and add notes to the submission</p>
            <div v-for="(note, index) in notesPreview">
              <div class="row mx-0">
                <strong class="col-auto">{{ index + 1 }}. </strong>
                <div class="col">
                  <div class="row align-items-center mx-0">
                    <strong class="col pl-0">{{ note.subject }}
                    </strong>
                  </div>
                  <div class="row mx-0 my-2" v-if="note.note">
                    <div>
                      <pre :id="'noteRow-'+note.applicationNoteId" class="wrap-pre-tag mb-0">{{ note.note }}</pre>
                    </div>
                  </div>
                  <div class="row align-items-center justify-content-end mx-0">
                    <small class="col text-info pl-0">Created by {{note.appUserName}} on {{note.date | ociTimestamp}}</small>
                  </div>
                </div>
                </div>
                <hr v-if="index < notesPreview.length-1">
              </div>
            </div>
            <div v-show="editMode" class="p-3">
            <p class="px-3" v-if="(!notes || notes.length===0) && !newNote">No notes have been created</p>
            <div v-if="newNote && localNote">
              <div class="mx-4">
                  <strong class="row align-items-center mx-0 text-primary py-2"> 
                    <i class="fa fa-sticky-note-o"></i>&nbsp New Note
                  </strong>
                  <div class="row align-items-center mx-0 mb-2">
                    <fg-input v-model="localNote.subject" class="col pl-0 mb-0" placeholder="Subject"></fg-input>
                    <el-checkbox
                      class="col-auto m-0"
                      :id="'includeInSubmission-'+notes.length"
                      v-model="localNote.includeInLenderSubmission">
                    </el-checkbox>
                    <small :class="[{'text-primary font-weight-bold' : localNote.includeInLenderSubmission},'col-auto m-0 pl-0']" :for="'includeInSubmission-'+notes.length">Include in submission</small>
                    <a style="cursor:pointer" class="text-danger col-auto px-1" @click="closeNote"><small>Cancel</small></a>
                  </div>
                  <div class="row mx-0">
                    <textarea class="oc-note-body" v-bind:id="'note-'+notes.length" 
                    v-model="localNote.note" placeholder="Enter your note here...">
                    </textarea>
                    <!-- <pre v-bind:id="'note-'+index" class="wrap-pre-tag mb-0">{{ note.note.substring(0,200) + (note.note.length > 200 ? '...' : '') }}</pre> -->
                  </div>
                  <div class="row align-items-center mx-0 my-2">
                    <div class="col pl-0">
                      <el-button plain class="py-2" style="width: 100px"
                        size="small" type="success" @click="save(); closeNote()"
                        title="Save this note">Save
                      </el-button>
                    </div>
                  </div>
              </div>
              <hr v-if="notes && notes.length>0">
            </div>
            <div ref="notesSummary"
                  v-for="(note,index) in notes">
            <div class="row mx-0">
              <strong :class="[{'oc-not-included' : !note.includeInLenderSubmission},'col-auto']">{{ index + 1 }}. </strong>
              <div v-if="localNote && note.applicationNoteId === localNote.applicationNoteId" class="col">
                <!-- <pre>{{note}}</pre>
                <pre>{{localNote}}</pre> -->
                <div class="row align-items-center mx-0 mb-2">
                  <fg-input placeholder="Subject" :disabled="preventSave" v-model="localNote.subject" class="col pl-0 mb-0"></fg-input>
                  <el-checkbox
                    class="col-auto m-0"
                    :id="'includeInSubmission-'+index"
                    v-model="localNote.includeInLenderSubmission"
                    :disabled="preventSave">
                  </el-checkbox>
                  <small  :class="[{'text-primary font-weight-bold' : localNote.includeInLenderSubmission},'col-auto m-0 pl-0']">Include in submission</small>
                  <a style="cursor:pointer; font-size: 11px" class="text-danger col-auto px-1" @click="closeNote">Cancel</a>
                </div>
                <div class="row mx-0">
                  <textarea :disabled="preventSave" 
                    class="oc-note-body" 
                    v-bind:id="'note-'+index" v-model="localNote.note">
                  </textarea>
                  <!-- <small>{{localNote && localNote.note ? 'Word count: ' + localNote.note.trim().split(/\s+/).length : 0}}</small> -->
                  <!-- <pre v-bind:id="'note-'+index" class="wrap-pre-tag mb-0">{{ note.note.substring(0,200) + (note.note.length > 200 ? '...' : '') }}</pre> -->
                </div>
                <div class="row align-items-center mx-0 my-2">
                  <!-- <small class="col-auto pl-0 text-info">Created by {{localNote.appUserName}} on {{localNote.date | ociTimestamp}}</small> -->
                  <div class="col pl-0">
                    <el-button plain class="py-2" style="width: 100px" v-show="!preventSave"
                      size="small" type="success" @click="save(); closeNote()"
                      title="Save this note">Update
                    </el-button>
                    <el-button plain class="py-2" style="width: 100px" v-show="!preventDelete"
                      size="small" type="danger" @click="deleteNote"
                      title="Delete this note"><i class="fa fa-trash"></i> Delete
                    </el-button>
                  </div>
                </div>
              </div>
              <div v-else-if="note" :class="[{'oc-not-included' : !note.includeInLenderSubmission},'col']">
                <div class="row align-items-center mx-0">
                  <strong class="col pl-0">{{ note.subject }}
                  </strong>

                  <el-checkbox
                    class="col-auto m-0"
                    :id="'includeInSubmission-'+index"
                    v-model="note.includeInLenderSubmission"
                    @change="save(note)">
                  </el-checkbox>
                  <small  :class="[{'text-primary' : note.includeInLenderSubmission},'col-auto m-0 pl-0 font-weight-bold']">Include in submission</small>
                  <!-- <small title="Included in lender submission" v-if="note && note.includeInLenderSubmission" class="font-weight-bold text-primary col-auto">Included in submission</small> -->
                  <a v-if="isNoteOwner(note.appUser)" class="col-auto px-1" style="cursor:pointer; font-size: 11px; width: 50px" @click="setSelectedNote(note)"><i class="fa fa-edit"></i> Edit</a>
                  <small v-else class="col-auto text-info fa fa-lock px-1" :title="'Only '+note.appUserName+' can edit this note'" style="width: 50px"></small>
                </div>
                <div class="row mx-0 my-2" v-if="note.note">
                  <pre :id="'editNoteRow-'+note.applicationNoteId" class="truncated wrap-pre-tag mb-0">{{ note.note }}</pre>
                  <!-- below enables show more/less toggle if note is truncatable -->
                  <div v-if="truncatableNotes.includes('editNoteRow-'+note.applicationNoteId)">
                    <a v-if="expandedNotes.includes('editNoteRow-'+note.applicationNoteId)" class="text-primary" style="cursor:pointer; font-size: 11px" @click="truncateNote('editNoteRow-'+note.applicationNoteId)">show less</a>
                    <a v-else class="text-primary" style="cursor:pointer; font-size: 11px" @click="showNote('editNoteRow-'+note.applicationNoteId)">...show more</a>
                  </div>
                </div>
                <div class="row align-items-center justify-content-end mx-0">
                  <small class="col text-info pl-0">Created by {{note.appUserName}} on {{note.date | ociTimestamp}}</small>
                </div>
              </div>
              </div>
              <hr v-if="index < notes.length-1">
            </div>
          </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
import {createHelpers} from 'vuex-map-fields';
import {SUBMIT, LOAD, ADD, DELETE} from '@/store/action-types'
import {Checkbox, CheckboxGroup, Button, RadioGroup, RadioButton} from 'element-ui';
import swal from 'sweetalert2';

const {mapActions} = createNamespacedHelpers('loanAppHelpers/notes');
const {mapFields} = createHelpers({
  getterType: 'loanAppHelpers/notes/getField',
  mutationType: 'loanAppHelpers/notes/updateField',
});

export default {
  name: "Notes",
  data() {
    return {
      editMode: 0,
      newNote: null,
      selectedNote: null,
      localNote: null,
      expandedNotes: [],
      truncatableNotes: []
    }
  },
  components: {
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [CheckboxGroup.name]: CheckboxGroup,
  },
  props: {
    loanApplicationId: null,
    showNotes: false,
    activeNotes: true
  },
  computed: {
    ...mapFields([
      'selected.applicationNoteId',
      'selected.note',
      'selected.date',
      'selected.subject',
      'selected.appUserName',
      'selected.includeInLenderSubmission'
    ]),
    preventSave: {
      get() {
        // @TODO: build out ACL perimeters ...
        // appUser will exist with both an existing and a new row.. that's our reference

        let appUser = this.$store.state.loanAppHelpers.notes.selected.appUser;
        // let appUser = this.localNote.appUser;
        // console.log(this.$store.state.loanAppHelpers.notes.selected);
        // then we check that current appUser is the originator of the note (will expand to allow for role exceptions)
        let appUserIsOwner = ((appUser && appUser.userId) ?
          (appUser.userId === this.$store.state.appUser.userId) : null)
        // if all conditions are met, let's enable the actions
        if (appUser && appUserIsOwner) {
          return false
        }
        return true
      }
    },
    preventDelete: {
      get() {
        // for now, following same rules as preventSave, so keep it simple
        return this.preventSave
      }
    },
    notes: {
      // can also implement with ...mapNotesList([ 'notes' ])..  I like this computed approach for the select lists
      // as you can override the mutation and throw an error as we shouldn't mutate on a select v-for anyhow
      get() {
        if (this.$store.state.loanAppHelpers) {
          return this.$store.state.loanAppHelpers.notes.notes;
        }
      },
      set() {
        console.warn('trying to set into notes list..  mutation not supported from here')
      }
    },
    notesPreview() {
      if (this.notes) {
        return this.notes.filter(item=>item.includeInLenderSubmission)
      }
    },
  },
  watch: {
    notes: {
      deep: true,
      handler() {
        this.findTruncatableNotes()
      }
    }
  },
  methods: {
    ...mapActions({
      submit: SUBMIT,
      remove: DELETE,
      newRow: ADD,
      reload: LOAD
    }),
    async save(note){
      if(note){
        this.$store.commit('loanAppHelpers/notes/SET_SELECTED', note);
      } else {
        this.$store.commit('loanAppHelpers/notes/SET_SELECTED', this.localNote);
      }
      await this.submit();
      await this.reload(this.loanApplicationId);
    },
    async deleteNote() {
      let note = this.selectedNote;
      let value = null;
      await swal({
        title: 'Are you sure?',
        text: 'The note will be permanently deleted',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Delete',
        buttonsStyling: true
      }).then((result) => {
        value = result.value;
      });
      if (value) {
        await this.closeNote();
        await this.remove();
        await this.reload(this.loanApplicationId);
      }
    },
    addNote() {
      this.newRow();
      this.newNote = true
      this.localNote = JSON.parse(JSON.stringify(this.$store.state.loanAppHelpers.notes.selected))
    },
    closeNote() {
      // this.selectedNote = false;
      this.newNote = false;
      this.localNote = null;
    },
    setSelectedNote(note) {
      this.newNote = false;
      this.selectedNote = note;
      this.localNote = JSON.parse(JSON.stringify(note));
      this.$store.commit('loanAppHelpers/notes/SET_SELECTED', note);
    },
    async sleep(time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    isNoteOwner(appUser) {
       let appUserIsOwner = ((appUser && appUser.userId) ?
          (appUser.userId === this.$store.state.appUser.userId) : null)
        // if all conditions are met, let's enable the actions
        if (appUser && appUserIsOwner) {
          return true
        }
        return false
    },
    findTruncatableNotes() {
      this.$nextTick(()=>{
        /* by default, all notes are limited to 3 lines, if this causes the scroll height (total content height)
        to be larger than the client (displayed) height, it is "truncatable" and the content size should be toggleable (show more/show less)*/
        let truncated = document.querySelectorAll('.truncated')
          truncated.forEach((el)=>{
            // Note is truncatable if scrollheight > client height
            if (el.scrollHeight > el.clientHeight && !this.truncatableNotes.includes(el.id)) {
              this.truncatableNotes.push(el.id)
            // if a note is changed and falls within the truncate limit, remove from the list (no longer need show more/ show less)
            } else if (el.scrollHeight === el.clientHeight && this.truncatableNotes.includes(el.id)) {
              this.truncatableNotes.splice(this.truncatableNotes.indexOf(el.id), 1)
            }
          })
      })
    },
    startEditing(val) {
      // edit is toggled, find notes which need to be truncated
      if (val) {
       this.findTruncatableNotes()
      }
    },
    truncateNote(id) {
      // add the truncated class back, remove it from the expanded notes list
      document.getElementById(id).classList.add('truncated')
      this.expandedNotes.splice(this.expandedNotes.indexOf(id),1)
    },
    showNote(id) {
      // show full content of note by removing the truncated class, add it to the expanded notes list
      document.getElementById(id).classList.remove('truncated')
      this.expandedNotes.push(id)
    }
  },
}
</script>

<style scoped>
.oc-note-body {
  width: 100%;
  height: 100px;
  /* margin-top: 8px; */
  border: solid 1px rgba(136, 136, 136, 0.3);
  border-radius: 5px;
  padding: 10px;
  font-size: 12px;
  /* background-color: #ffffff; */
}
/*.oc-note-body:active{
   margin-top: 8px;
   border: solid 1px #979797;
   background-color: #fcfcfc;
 }*/
.oc-note-body:focus {
  outline: none;
}


.list-button {
  width: 100%;
  border: 0;
  border-bottom: 1px solid #636363;
  border-radius: 0;
  background-color: unset;
  margin-bottom: 1px;
  color: #636363;
}

.list-button:hover {
  /*background-color: #636363;*/
  background-color: #e4f1f9;
  /* top border-radius 0 to tuck into the list bottom-border */
  /*border-top-left-radius: 0px;*/
  /*border-top-right-radius: 0px;*/
  /*border-bottom-left-radius: 3px;*/
  /*border-bottom-right-radius: 3px;*/
  color: black;
  /* setting margin and padding to just envelope the surrounding borders */
  /*margin: -2px 6px 0 0;*/
  /*padding-right: 6px;*/
}

input {
  padding-left: 4px;
}

input[type="text"]:disabled {
  border: 0;
  background-color: unset;
  margin: 4px; /* removing the border causes the elements to shift slightly..  margin:4px corrects for this */
}
.wrap-pre-tag {
  line-height: 1.5em; /*important for .truncated to work correctly*/
  white-space: pre-wrap;
}
.oc-not-included pre {
  opacity: 0.9;
}
.oc-not-included strong, strong.oc-not-included {
  opacity: 0.6;
}
.oc-note-subject {
  /* text-overflow: ellipsis; */
}

.truncated {
  max-height: 3em;
  overflow: hidden;
  /* text-overflow: ellipsis; */
}
</style>
